<template>
    <div class="bulkAssign">
        <div v-if="!isEmployeeAllowed">
            <NotAllowed />
        </div>
        <div v-else>
            <div class="o-main-content-area o-main-content-area-assign-adjust c-responsive-fixwidth">
                <div class="table_header_wrapper">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="pagination">
                                <h1 class="h1">
                                    Jobs / Events: 
                                    <a href="javascript: void(0)" @click="backToJobDetails()">
                                        {{ jobTitle }}
                                    </a>
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    <a href="javascript: void(0)" @click="goToCalls('individual')">
                                        Individual Calls
                                    </a> 
                                    / 
                                    <a class="active-color" href="javascript: void(0)" @click="goToCalls('bulk')">Bulk Calls</a>
                                    <i class="fa fa-angle-right" aria-hidden="true"></i> 
                                    <strong>Assign</strong>
                                </h1>
                            </div>
                        </div>
                        <div class="col-md-12 text-rightt">
                            <form class="form-inline table_form_alt table_form_alt_align">
                                <div class="form-group">
                                    <label class="common-label-text">Status Level:</label>
                                    <label class="common-label-input o-custom-dropdown">
                                        <select class="form-control o-min-width select_margin_adjust" @change="onChangeStatus()" id="selectedStatus" tabindex="2" v-model="selectedStatusId">
                                            <option v-for="(status, sIndex) in statusList" :key="sIndex" :value="status.id">{{status.name}}</option>
                                            <option value="">All</option>
                                        </select>
                                        <span class="o-custom-drop-arrow" style="right: -38px;"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                    </label>
                                </div>
                                <div class="form-group">
                                    <label class="common-label-text">Sort By:</label>
                                    <label class="common-label-input o-custom-dropdown">
                                        <select 
                                            @change="getEmployeesBySkill()" 
                                            v-model="selectedSortType" 
                                            tabindex="3" 
                                            id="assign-emp-sort" 
                                            class="form-control o-min-width select_margin_adjust"
                                        >
                                            <option value="">- - - Select - - -</option>
                                            <option value="fname_asc">FirstLast (Employee name)</option>
                                            <option value="lname_asc">Last,First (Employee name)</option>

                                            <option value="wishlist_asc">Wishlist Timestamp (Ascending)</option>
                                            <option value="wishlist_desc">Wishlist Timestamp (Decending)</option>

                                            <option value="participation_asc">Participation (Ascending)</option>
                                            <option value="participation_desc">Participation (Decending)</option>

                                            <option value="participation_july_june_asc">Participation July June (Ascending)</option>
                                            <option value="participation_july_june_desc">Participation July June (Decending)</option>

                                            <option value="emp_seniority">Employee Seniority (Ascending)</option>
                                            <option value="emp_seniority_desc">Employee Seniority (Decending)</option>


                                            <option value="skill_seniority">Skill Seniority (Ascending)</option>
                                            <option value="skill_seniority_desc">Skill Seniority (Decending)</option>

                                            <option value="location_asc">Location (Ascending)</option>
                                            <option value="location_desc">Location (Decending)</option>

                                            <option value="shift_total_asc">Total Shift (Ascending)</option>
                                            <option value="shift_total_desc">Total Shift (Decending)</option>

                                            <option value="shift_weekly_asc">Weekly Shift (Ascending)</option>
                                            <option value="shift_weekly_desc">Weekly Shift (Decending)</option>

                                            <option value="shift_july_june_asc">Shift July June (Ascending)</option>
                                            <option value="shift_july_june_desc">Shift July June (Decending)</option>

                                            <option value="shift_YTD_asc">Shift YTD (Ascending)</option>
                                            <option value="shift_YTD_desc">Shift YTD (Decending)</option>

                                            <option value="decline_total__asc">Decline Total (Ascending)</option>
                                            <option value="decline_total__desc">Decline Total (Decending)</option>

                                            <option value="decline_weekly_asc">Decline Weekly (Ascending)</option>
                                            <option value="decline_weekly_desc">Decline Weekly (Decending)</option>

                                            <option value="decline_july_june_asc">Decline July June (Ascending)</option>
                                            <option value="decline_july_june_desc">Decline July June (Decending)</option>

                                            <option value="decline_YTD_asc">Declines YTD (Ascending)</option>
                                            <option value="decline_YTD_desc">Declines YTD (Decending)</option>

                                            <option value="conflicts_asc">Conflicts (Ascending)</option>
                                            <option value="conflicts_desc">Conflicts (Decending)</option>

                                            <option value="wishlist_seniority">Wishlist by Seniority (Ascending)</option>
                                            <option value="wishlist_seniority_desc">Wishlist by Seniority (Decending)</option>

                                            <option value="member_since_asc">Member Since (Ascending)</option>
                                            <option value="member_since_desc">Member Since (Decending)</option>

                                            <option value="date_of_hire_asc">Date of Hire (Ascending)</option>
                                            <option value="date_of_hire_desc">Date of Hire (Decending)</option>

                                            <option value="last_offer_asc">Last Offer  (Ascending)</option>
                                            <option value="last_offer_desc">Last Offer (Decending)</option>

                                            <option value="last_assigned_asc">Last Assigned  (Ascending)</option>
                                            <option value="last_assigned_desc">Last Assigned (Decending)</option>

                                            <option value="last_confirmed_asc">Last Confirmed  (Ascending)</option>
                                            <option value="last_confirmed_desc">Last Confirmed (Decending)</option>
                                        </select>

                                        <span class="o-custom-drop-arrow" style="right: -54px;"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                        
                                    </label>
                                </div>
                            </form>

                            <ul class="o-filter-area">
                                <li class="o-search-field">
                                    <div class="input-group stylish-input-group">
                                        <input type="text" 
                                            v-on:keyup="updateValue" 
                                            v-model="searchBoxvalue" 
                                            tabindex="4" id="assign-emp-search" 
                                            class="form-control table_search" 
                                            placeholder="Name,Zip,City">

                                            <span class="input-group-addon">
                                                <button @click="searchBoxvalue = ''; updateValue()">
                                                    <span class=""><i class="fa fa-times" aria-hidden="true"></i></span>
                                                </button>
                                            </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="c-common-space o-top-heading c-responsive-fixwidth table_sub_left no-margin table_tagline">
                        <p class="h5-v1 h5-mod"><span>{{bulkCallSkillName+' for '+getDate(bulkCallStartTime)}}:</span> {{getTime(bulkCallStartTime)}} - {{getTime(bulkCallEndTime)}}</p>
                        <ul class="o-inline-list list-mod">
                            <li class="h5-v1 h5-mod">{{unassignedCallCount+' Calls unassigned'}}</li>
                            <li class="right-btn">
                                <a id="btn-bulk-assign" href="javascript: void(0)" 
                                    @click="assignEmployee()" 
                                    class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green" 
                                    :class="(selectedEmployeesToAssign.length!=0)?'':'deactivate-btn'">
                                    <i aria-hidden="true" class="fa fa-plus"></i> 
                                    Assign
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="o-ndividualArea c-responsive-fixwidth">
                <div class="o-ndividualTable assigntab" style="padding-top: 0px;">
                    <div class="extra-list-table-outer table_main_content" v-if="selectedEmployeesToAssign">
                        <div class="tbl-header">
                            <div class="o-calls-table bulk-table-list c-radius3 table_header_black table_1">
                                <div class="calls-table-row">
                                    <div class="calls-table-cell tcell_1">
                                        <div class="table-td-border-right">
                                            <div class="calls-table-cell-inner-table">
                                            <div class="table_heading th_cell_1">List</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="calls-table-cell tcell_1">
                                
                                    </div>
                                    <div class="calls-table-cell tcell_1">

                                    </div>
                                    <dynamicHeader v-for="(item, index) in callAssigmentSettings" :client="client" :columnLabel="item" :sortType="selectedSortType" :key="index"></dynamicHeader>
                                    <div v-if="job && job.hts_flag" class="calls-table-cell tcell_1">
                                        <div class="calls-table-cell-inner-table">
                                            <div class="table_heading th_cell_1">HTS</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <v-infinite-scroll
                            id="page-data-focus"
                            ref="scrollContainer"
                            tabindex="1"
                            :loading="loading"
                            :offset="100"
                            class="tbl-content"
                            @bottom="onPageChangeScrollDown"
                            @top="onPageChangeScrollUp"
                        >
                            <div v-for="(employee, row) in employees" :key="row" 
                                :style="{'border': '2px solid '+employee.link_color, 'box-shadow': '0px 0px 5px 0px '
                                +employee.link_color}" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-radius3 table_1"
                            >
                                <div class="calls-table-row">
                                    <div class="calls-table-cell tcell_1 calls-table-alphabet" :style="{'background-color': employee.link_color}">
                                        <span>{{getStatusName(employee.status_name)}} <br/> ({{employee.status_priority}})</span>
                                    </div>
                                    <div :class="{'isDisabled':!getPower('callAssign')}" class="calls-table-cell tcell_1">
                                        <div class="checkbox o-custom-radio">

                                            <label 
                                                v-if="!checkVacationWithinCall(employee.vacations) && 
                                                !recurringUnavailability(employee.available_times) && 
                                                !getDeclineStatus(employee.call_actions) && 
                                                !getCallOutStatus(employee.call_actions) && 
                                                (employee.bookings.length==0||!checkThisClickCooking(employee.bookings))">
                                            
                                                <div class="display-inline">                                                
                                                    <input 
                                                        @change="checkOtherBookingConflict(employee,$event.srcElement.checked)" 
                                                        :value="employee.id" v-model="selectedEmployeesToAssign" 
                                                        :disabled="employee.assign_button&&selectedEmployeesToAssign.length >= unassignedCallCount && 
                                                        selectedEmployeesToAssign.indexOf(employee.id) == -1" type="checkbox" name="o4" checked="">
                                                    <span class="w-50px">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                        <span class="global-skill-display" v-if="employee.global_skills">GS</span>
                                                    </span>
                                                </div>
                                            </label>

                                            <label v-if="checkThisClickCooking(employee.bookings) && employee.bookings.length!=0" class="w-50px">
                                                <a href="javascript: void(0)" @click="checkAccessToClearAssign(employee)">
                                                    <i class="fa fa-minus-circle" :class="{ 'fa-minus-circle-red':checkAssigned(employee) }" aria-hidden="true" style="font-size: 24px;"></i>
                                                    <span class="global-skill-display" v-if="employee.global_skills">GS</span>
                                                </a>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="calls-table-cell tcell_1">
                                        <div class="o-post-logged o-post-logged--table-user">
                                        <div class="o-user-profile-img" :id="'scrollTop'+row">
                                            <img v-if="employee.image != '' && employee.image != 'NULL'" :src="(employee.image)"  id='img-upload'/>
                                            <img v-if="employee.image == '' || employee.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload' />
                                        </div>
                                        </div>
                                    </div>

                                    <dynamicColumns 
                                        v-for="(item, index) in callAssigmentSettings" 
                                        :employee="employee" :columnLabel="item" 
                                        :client="client" :selectedSortType="selectedSortType" 
                                        :callStartTime="bulkCallStartTime" 
                                        :callEndTime="bulkCallEndTime" 
                                        :userDateFormat="userDateFormat" 
                                        :isSteward="isSteward" 
                                        :isDispatcher="isDispatcher" 
                                        :userTimeFormat="userTimeFormat" 
                                        :key="index">
                                    </dynamicColumns>
                                    <div v-if="job && job.hts_flag" class="calls-table-cell tcell_1">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <div 
                                                class="text-center" 
                                                style="font-size:20px;" 
                                                v-if="!checkVacationWithinCall(employee.vacations) && 
                                                !recurringUnavailability(employee.available_times) && 
                                                !getDeclineStatus(employee.call_actions) && !getCallOutStatus(employee.call_actions) && 
                                                employee.bookings.length==0 && employee.hts.length==0"
                                            >
                                                <a @click="ckeckHTS(employee.id)">
                                                    <el-tooltip class="item" effect="dark" content="Click to check availability of HTS" placement="top-end">
                                                        <i class="fa fa-eye" aria-hidden="true"></i>
                                                    </el-tooltip>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="page-scroll-bottom"></div>
                            <div 
                                v-if="loading" 
                                v-loading="loading" 
                                class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" 
                                style="height: 50px;"
                            >
                                <div class="calls-table-row">
                                    <div class="calls-table-cell" style="height: 60px;">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div 
                                v-if="employees.length<=0 && apiData && !loading" v-loading="loading" 
                                class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" 
                                style="height: 50px;"
                            >
                                <div class="calls-table-row">
                                    <div class="calls-table-cell" style="height: 60px;">

                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <div>Empty Employee List</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-infinite-scroll>
                    </div>
                    <div class="el-pagination-assign">
                        <el-pagination
                            :current-page.sync="currentPage"
                            :page-size="pageSize"
                            :total="totalLimit"
                            layout="prev, pager, next"
                            @current-change="onPageChange"
                        />
                    </div>
                </div>
            </div>
            
            <modal name="limitExcedPop"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
                <div  tabindex="-1" role="dialog">
                    <div  role="document">
                        <div class="modal-content o-common-modal-content">
                            <div class="modal-header text-center">
                                <button 
                                    @click="closeLimitPop()" 
                                    type="button" 
                                    class="close custom-modal--close" 
                                    data-dismiss="modal" 
                                    aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h1 class="modal-title">
                                    Bulk Assign
                                </h1>
                            </div>
                            <div class="modal-body c-common-box-shadow o-modal-body o-no-padding-modal">
                                <div class="o-running-strip o-vacation-history text-center">
                                        You have assigned all calls for <strong>{{bulkCallSkillName}}</strong>
                                </div>
                            </div>

                            <div class="modal-footer text-center">
                                <a 
                                    id="btn-bulk-assign-modal" 
                                    href="javascript: void(0)" 
                                    @click="assignEmployee()" 
                                    class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green" 
                                    :class="(selectedEmployeesToAssign.length!=0)?'':'deactivate-btn'"
                                >
                                    <i aria-hidden="true" class="fa fa-plus"></i> 
                                    Assign
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>

            <modal name="otbConflictPop"  height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
                <div  tabindex="-1" role="dialog">
                    <div  role="document">
                        <div class="modal-content o-common-modal-content">
                            <div class="modal-header text-center">
                                <button 
                                    @click="closeOtbConflictPop()" 
                                    type="button" 
                                    class="close custom-modal--close" 
                                    data-dismiss="modal" aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h1 class="modal-title">WARNING !</h1>
                            </div>
                            <div class="modal-body">
                                    <div class="obt-conflict-body">
                                        Selecting this user will create the opportunity for a 2x Booking in another client.
                                        Proceed with Caution and make direct contact with the employee!
                                    </div>
                                </div>

                                <div class="modal-footer text-center">
                                <a id="btn-bulk-assign-modal" 
                                    href="javascript: void(0)" 
                                    @click="closeOtbConflictPop()" 
                                    class="c-common-btn c-common-btn--small obt-modal-cancel-btn"
                                > 
                                    Cancel
                                </a>
                                <a id="btn-bulk-assign-modal" href="javascript: void(0)" 
                                    @click="proceedWithConflict(selectedEmployeeID)" 
                                    class="c-common-btn c-common-btn--small obt-modal-proceed-btn"
                                >
                                    Proceed
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import { mapGetters, mapActions } from 'vuex';
    import { global } from '../../../global.js';
    import service from '../../../services.js';
    import { bus } from '../../../main';
    import dynamicColumns from './dynamicColumns';
    import dynamicHeader from './dynamicHeader';
    import NotAllowed from '@/components/NotAllowed';
    let timeout = null;
    export default {
        components: {
            'dynamicHeader': dynamicHeader,
            'dynamicColumns': dynamicColumns,
            'NotAllowed': NotAllowed
        },
        data() {
            return {
                isEmployeeAllowed: true,
                timerState: null,
                polling: null,
                currentPage: 1,
                lastLoadedPage: 0,
                isFirstPageLoad: false,
                loading:false,
                apiData:false,
                empProfile: '',
                getBaseURL: '',
                employees: [],
                storeMore: [],
                totalLimit:0,
                pageSize:100,
                selectedSortType: 'seniority',
                nextPageUrl: '',
                statusList: [],
                selectedEmployeesToAssign: [],
                selectedEmployeesToHTS:[],
                selectedStatusId:'',
                tempStatus: '',
                turnoverTime:'',
                customField1: '',
                customField2: '',
                showCustom: '',
                callAssigmentSettings:'',
                map_name: "googleMap",
                addresses:'',
                searchBoxvalue:'',
                jobTitle:'',
                client: null,
                unassignedCallCount:0,
                job:null,
                statusSortType:'priority',
                userDateFormat: null,
                userTimeFormat:null,
                opnOtherBookingConflictModal: false,
                selectedEmployeeID: null,
                scrollType: null,
                isSteward: 0,
                isDispatcher: 0,
                loadingDebounceTimer: null,
                isPaginationChange: false,
                scrollDirection: null
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                jobID: 'selectedJobId',
                selectedBulkCallId: 'selectedBulkCallId',
                bulkCallStartTime: 'bulkCallStartTime',
                bulkCallEndTime: 'bulkCallEndTime',
                bulkCallSkillId: 'bulkCallSkillId',
                selectedBulkCalls: 'selectedBulkCalls',
                noOfUnassignCall: 'noOfUnassignCall',
                bulkCallSkillName: 'bulkCallSkillName',
                callDate: 'callDate',
                getAssignPageStatus: 'getAssignPageStatus',
                getJob:'getJobDetails',
                clientDetails:'clientDetails',
                employeeStatusList:'employeeStatusList',

                employeeId: 'employeeId',
                userRoleSlug: 'userRoleSlug',
            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check = 
                (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? 
                "tablet" : 
                /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? 
                "phone" : "desktop");

                return("desktop" != check ? !0 : !1);
            },
            totalPages() {
                return Math.ceil(this.storeMore.length / this.pageSize);
            }
        },
        methods: {
            async checkStewardSkill(){
                this.isSteward = 0;
                await service
                .get("employee/" + this.employeeId + "/checkSkill", {
                    Authorization: this.userToken,
                    "cs3-context-role": this.userRole,
                    "cs3-context-clientId": this.userClientID,
                })
                .then((res) => {
                    this.isSteward = res.data.result;
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.isSteward = 0;
                    this.$Progress.fail();
                });
            },
            async checkDispatcherSkill(){
                this.isDispatcher = 0;
                await service
                .get("employee/" + this.employeeId + "/checkDispatchBySkill", {
                    Authorization: this.userToken,
                    "cs3-context-role": this.userRole,
                    "cs3-context-clientId": this.userClientID,
                })
                .then((res) => {
                    this.isDispatcher = res.data.result;
                    console.log(this.isDispatcher);
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.isDispatcher = 0;
                    this.$Progress.fail();
                });
            },
            async getEmpDetails() {
                this.$Progress.start();
                await service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.userDateFormat = res.data.result.date_format;
                    this.userTimeFormat = res.data.result.time_format;
                }).catch((err) => {
                    console.log(err);
                });
            },
            getStatusName(name){
                let temp = name.substring(0, 3);
                return temp.toUpperCase();
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            onPageChangeScrollUp(){
                if (this.loading || this.ignoreScrollEvents) return;
                if (this.currentPage <= 1) return; // first page
                this.loading = true;
                this.isPaginationChange = true;
                this.scrollDirection = 'up';
                this.currentPage--;
                this.updatePagedData();
                this.loading = false;
            },

            updatePagedData() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;

                if (this.isPaginationChange) {
                    // On pagination click, replace with new slice
                    this.employees = this.storeMore.slice(start, end);
                } else if (this.scrollDirection === 'down') {
                    const newItems = this.storeMore.slice(start, end);

                    // Filter to only add items not already present
                    const existingIds = new Set(this.employees.map(e => e.id));
                    const filteredNewItems = newItems.filter(item => !existingIds.has(item.id));

                    // Only concat if there are new items (protects against double fire at last page)
                    if (filteredNewItems.length > 0) {
                    this.employees = this.employees.concat(filteredNewItems);
                    }
                    // Else: do NOT modify employees, prevents duplicates
                } else if (this.scrollDirection === 'up') {
                    // Only implement if you use upward infinite scroll
                    // ...similar logic as above, with prepending
                }

                this.isPaginationChange = false;
                this.scrollDirection = null;
            },
            
            onPageChangeScrollDown(){
                if (this.loading) return;

                // Compute total number of pages:
                const totalPages = Math.ceil(this.totalLimit / this.pageSize);
                if (this.currentPage >= totalPages) return; // do NOT increment past last page

                this.loading = true;
                this.scrollDirection = 'down';
                this.isPaginationChange = false;
                this.currentPage++;
                this.updatePagedData();
                this.loading = false;
            },

            onPageChange(page){
                if (this.loading) return;

                this.loading = true;
                this.isPaginationChange = true;
                this.scrollDirection = null;
                this.currentPage = page;
                // Ignore scroll events during programmatic scrollTop setting
                this.ignoreScrollEvents = true;

                this.updatePagedData();

                this.$nextTick(() => {
                    if (this.$refs.scrollContainer) {
                        this.$refs.scrollContainer.$refs.container.scrollTop = 0;
                    }
                    setTimeout(() => {
                        this.ignoreScrollEvents = false; // re-enable scroll handling after short delay
                    }, 100);
                    
                    this.loading = false;
                });
            },

            restoreScrollPosition(direction) {
                // Use this method to preserve scroll position on scroll up/down via infinite scroll.
                // If you want, you can save last scrollTop before data change and restore with adjustments.
                // Here is a simple placeholder you can enhance:
                const container = this.$refs.scrollContainer?.$refs?.container;
                if (!container) return;

                if (direction === 'up') {
                // For scroll up, scroll to bottom of new content to maintain position
                    container.scrollTop = container.scrollHeight - container.clientHeight;
                } else {
                // For scroll down, scroll to top of container (or implement your own logic)
                    container.scrollTop = 0;
                }
            },

            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            // decline Call
                            case 'Declined':
                                declines.push(call);
                            break;
                            // pass call
                            case 'Passed':
                                passes.push(call);
                            break;
                            // call out
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            // Call time out
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    // decline Call
                    case 'Declined':
                        return declines;
                    break;
                    // pass call
                    case 'Passed':
                        return passes;
                    break;
                    // call out
                    case 'Call Out':
                        return callouts;
                    break;
                    // Call time out
                    case 'Timed Out':
                        return timeouts;
                    break;
                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },

            checkThisClickCooking(bookings){
                let status = false;
                for(let i=0; i<bookings.length; i++){
                    if(bookings[i].client_id == this.userClientID) {
                        status = true;
                    }
                }
                return status;
            },
            ckeckHTS(emp_id){
                service.get('employee/checkEmployeeAvailability', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'jobId':atob(this.$route.params.id),
                    'employeeId': emp_id
                }).
                then((res) => {
                    if(res.data.result.status){
                        this.$notify({
                            title: 'Success',
                            message: res.data.result.message,
                            type: 'success'
                        });
                    }else{
                        this.$notify({
                            title: 'Error',
                            message: res.data.result.message,
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            updateValue(){
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if(!this.searchBoxvalue){
                        // document.getElementById('page-data-focus').focus();
                    }
                    this.selectedStatusId = "";
                    if(this.searchBoxvalue == '') {
                        this.selectedStatusId = this.tempStatus;
                    }
                    this.getEmployeesBySkill();
                }, 1000);
            },
            async getClientData() {
                await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.client = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
            },

            async jobDetails() {
                await service.get('job/' + atob(this.$route.params.id), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.job=res.data.result;

                    this.jobTitle = this.job.title;

                    this.isSteward = this.job.employee_id==this.employeeId&&this.isSteward ? 1 : 0;

                    this.isDispatcher = this.job.dispatched_by.id == this.userID&&this.isDispatcher ? 1 : 0;
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },
            backToJobDetails(){
                this.$router.push({
                    path: `/jobDetails/`+this.$route.params.id
                });
            },
            goToCalls(callType) {
                this.$store.dispatch('setSelectedCallList', callType);
                this.$router.push({
                    path: `/viewCalls/`+this.$route.params.id
                });
            },

            checkAccessToClearAssign(employee) {
                let call = null;
                if(this.userRoleSlug == 'employee') {
                     let index = employee.bookings.findIndex((item) => item.client_id == this.userClientID);
                    if(index > -1) {
                        call = employee.bookings[index];
                    } else {
                        call = employee.bookings[0];
                    }
                    if(call.job_id == atob(this.$route.params.id)) {
                        this.clearAssign(employee.bookings);
                    } else if(call.created_by == this.userID) {
                        this.clearAssign(employee.bookings);
                    } else{
                        this.$alert('you are not allowed to clear this assignment', 'Not Allowed!', {
                            confirmButtonText: 'OK',
                            callback: action => {
                                this.$message({
                                type: 'error',
                                message: 'Clearing the assignment was cancelled.'
                                });
                            }
                        });
                        return;
                    }
                } else {
                    this.clearAssign(employee.bookings)
                }

            },

            checkAssigned(employee) {
                let call = null;
                if(employee.bookings&&employee.bookings.length) {
                    let index = employee.bookings.findIndex((item) => item.client_id == this.userClientID);
                    if(index > -1) {
                        call = employee.bookings[index];
                    } else {
                        call = employee.bookings[0];
                    }
                    if(call.job_id != atob(this.$route.params.id)) {
                        return true;
                    }
                }
                return false;
            },

            clearAssign(bookings) {
               
                let call = null;
                if(bookings.length>0) {
                    
                    let index = bookings.findIndex((item) => item.client_id == this.userClientID);
                    if(index > -1) {
                        call = bookings[index];
                    } else {
                        call = bookings[0];
                    }
                }

                let callExist = []
                if(call)
                    callExist = this.selectedBulkCalls.filter(item => item.id==call.call_id);

                this.$confirm('Are you sure you would like to clear this Call?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    
                    service.del('call/' + call.call_id + '/assign', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'userId': this.userID,

                    }).then((res) => {
                        if(callExist.length>0){
                            this.unassignedCallCount+=1;
                        }
                        this.$notify({
                            title: 'Success',
                            message: 'Call cleared successfully.',
                            type: 'success'
                        });
                        this.getEmployeesBySkill();
                    }).catch((err) => {
                        console.log(err);
                        this.$notify({
                            type: 'error',
                            message: 'Something went wrong.',
                            title: 'Error'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Clear canceled'
                    });
                });
            },

            getDeclineStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Declined");
                if((data.length>0 || Object.keys(data).length>0)){
                    return true;
                }
                return false;
            },
            getCallOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Call Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDate(dateTime) {
                return dateTimeConvert.localDate(dateTime, 'MMMM D, YYYY');
            },

            assignEmployee() {
                var employees = this.employees;
                this.employees = [];
                this.loading = true;
                $("#btn-bulk-assign").addClass("deactivate-btn");
                $("#btn-bulk-assign-modal").addClass("deactivate-btn");
                let fromData = {
                    employeeIds: JSON.stringify(this.selectedEmployeesToAssign),
                    start: this.bulkCallStartTime,
                    end: this.bulkCallEndTime,
                    position: this.bulkCallSkillId,
                    skillId: this.bulkCallSkillId,
                    userId: this.userID,
                    jobId: atob(this.$route.params.id)
                };
                service.post('call/bulkAssign', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.employees = employees;
                    this.loading = false;
                    this.$modal.show("limitExcedPop");
                    this.$modal.hide("limitExcedPop");
                    $("#btn-bulk-assign").removeClass("deactivate-btn");
                    $("#btn-bulk-assign-modal").removeClass("deactivate-btn");
                    if(res.data.status_code == "1"){
                        this.$notify({
                            title: 'Success',
                            message: 'Employee assigned Successfully.',
                            type: 'success'
                        });
                        this.$router.push({
                            path: `/viewCalls/`+this.$route.params.id
                        });
                    }else{
                        this.getEmployeesBySkill();
                        this.selectedEmployeesToAssign = [];
                        this.$notify({
                            title: 'Error',
                            message: res.data.status_message,
                            type: 'error'
                        });
                    }
                    this.loading = false;
                }).catch((res) => {
                    this.employees = employees;
                    this.loading = false;
                    $("#btn-bulk-assign").removeClass("deactivate-btn");
                    $("#btn-bulk-assign-modal").removeClass("deactivate-btn");
                })
            },

            onChangeStatus() {
                this.tempStatus = this.selectedStatusId;
                this.getEmployeesBySkill();
                this.$store.dispatch('setAssignPageStatus', {
                    'uid': this.userID,
                    'status': this.selectedStatusId
                });
            },

            async getEmployeesBySkill() {
                this.$Progress.start();
                this.loading = true;
                this.apiData = false;
                this.employees = [];
                this.storeMore=[];
                await service.get('call/' + this.selectedBulkCallId + '/getEmployeesBySkill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-status-id': this.selectedStatusId,
                    'sort-type': this.selectedSortType,
                    'search': this.searchBoxvalue,
                    'jobId':atob(this.$route.params.id),
                }).then((res) => {
                    this.loading=false;
                    this.apiData=true;
                    this.nextPageUrl = null;
                    this.storeMore= res.data.result;
                    this.totalLimit = res.data.result?res.data.result.length:0;
                    this.currentPage = 1;
                    if(this.totalLimit <= this.pageSize){
                        this.employees = this.storeMore;
                    }else{
                        // this.onPageChange(1);
                        this.updatePagedData()
                    }
                    setTimeout(()=>{
                        this.isFirstPageLoad = true;
                    }, 5000);
                    this.$Progress.finish();
                    this.loading = false;
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.apiData=true;
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }else {
                      this.$notify({
                        title: 'Error!',
                        message: "Something went wrong.",
                        type: 'error'
                      });
                    }
                });
            },

            recurringUnavailabilityCheck(unavailability_list) {
                let flag = false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            console.log(unavailabilityList1[j]);
                            var temp = unavailabilityList1[j];

                            var unavailabilityStart = this.bulkCallStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var unavailabilityEnd = this.bulkCallStartTime.split(' ')[0]+' '+temp[1]+':00';

                            let isOverNightUnavailability = moment(unavailabilityStart,'YYYY-MM-DD HH:mm:ss').isAfter(moment(unavailabilityEnd,'YYYY-MM-DD HH:mm:ss'));
                            if(isOverNightUnavailability) {
                                console.log("check0");
                                if(unavailabilityStart.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {  //Check same date or not
                                    unavailabilityEnd = moment(unavailabilityStart, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");  // add 1 day
                                }
                                console.log(weekDaysNames[i]);
                                if((moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) || (moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]) || (moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) || (moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1])) {
                                    if(this.bulkCallStartTime.split(' ')[0] == unavailabilityStart.split(' ')[0]) {
                                        console.log("Check1");
                                        console.log(moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.bulkCallStartTime, this.bulkCallEndTime);
                                        return flag;
                                    }else if(this.bulkCallStartTime.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {
                                        console.log("Check2");
                                        console.log(moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.bulkCallStartTime, this.bulkCallEndTime);
                                        return flag;
                                    } else if(this.bulkCallEndTime.split(' ')[0] == unavailabilityStart.split(' ')[0]) {
                                        console.log("Check3");
                                        console.log(moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.bulkCallStartTime, this.bulkCallEndTime);
                                        return flag;
                                    }else if(this.bulkCallEndTime.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {
                                        console.log("Check4");
                                        console.log(moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.bulkCallStartTime, this.bulkCallEndTime);
                                        return flag;
                                    }
                                }
                                console.log(moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                console.log("Conditions failed");
                            }
                        }
                    }
                }
                // HillsPU
                return flag
            },

            recurringUnavailability(unavailability_list){
                var flag=false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            var temp = unavailabilityList1[j];
                            var start = this.bulkCallStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.bulkCallStartTime.split(' ')[0]+' '+temp[1]+':00';

                            let isOvernightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                            if(isOvernightUnavailability) {

                                end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                let day1UnavailabilityStart = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay1UnavailabilityEnd = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '23:59:59';
                                let day1UnavailabilityEnd = moment(tempDay1UnavailabilityEnd, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay2UnavailabilityStart = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '00:00:00';
                                let day2UnavailabilityStart = moment(tempDay2UnavailabilityStart, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let day2UnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");

                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.bulkCallStartTime, this.bulkCallEndTime, weekDaysNames[i],temp);
                                if(flag) return flag;

                                let dayIndex = i;
                                if(i==6) dayIndex=-1;

                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.bulkCallStartTime, this.bulkCallEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;

                                flag = this.checkCallDateUnavailability(day2UnavailabilityStart, day2UnavailabilityEnd, this.bulkCallStartTime, this.bulkCallEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;
                                
                            }else {
                                if((moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                                    let day1CallStart = moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let tempDay1CallEnd =  moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    let tempDay2CallStart =  moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let day2CallEnd = moment(this.bulkCallEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]){
                                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                                        if(flag) return flag;
                                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                                        if(flag) return flag;
                                    }
                                }else {
                                    if(moment(this.bulkCallStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        flag = dateTimeConvert.dateCheck(start,end, this.bulkCallStartTime, this.bulkCallEndTime);
                                        
                                        if(flag) return flag;
                                    }
                                }
                            }
                        }
                    }
                   
                }
                return flag;
            },

             checkCallDateUnavailability(start, end, callStartTime, callEndTime, day,temp) {
                let flag = false;
                if((moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                    let day1CallStart = moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let tempDay1CallEnd =  moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    let tempDay2CallStart =  moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let day2CallEnd = moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day){
                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                        if(flag) return flag;
                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                        if(flag) return flag;
                    }
                }else {
                    if(moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        flag = dateTimeConvert.dateCheck(start,end, callStartTime, callEndTime);
                        if(flag) return flag;
                    }
                }
                return flag;
            },

            recurringUnavailability1(unavailability_list){
                console.log("BulkCalls - call start:" + this.bulkCallStartTime + " Call end:" +this.bulkCallEndTime);
                let flag=false;
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    let dayNum1=moment(this.bulkCallStartTime).format('d');
                    dayNum1=Number(dayNum1)+1;
                    let unavailabilityList1=unavailabilityList[dayNum1];
                    for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                        var temp = unavailabilityList1[i];
                        var start = this.bulkCallStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.bulkCallStartTime.split(' ')[0]+' '+temp[1]+':00';
                        if(dateTimeConvert.dateCheck(start, end, this.bulkCallStartTime, this.bulkCallEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                    let dayNum2=moment(this.bulkCallEndTime).format('d');
                    dayNum2=Number(dayNum2)+1;
                    if(this.bulkCallStartTime.split(' ')[0] != this.bulkCallEndTime.split(' ')[0]) {
                        let unavailabilityList2=unavailabilityList[dayNum2];
                        for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                            var temp = unavailabilityList2[i];
                            var start = this.bulkCallEndTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.bulkCallEndTime.split(' ')[0]+' '+temp[1]+':00';
                            if(dateTimeConvert.dateCheck(start, end, this.bulkCallStartTime, this.bulkCallEndTime)){
                                flag=true;
                                return flag;
                            }
                        }
                    }
                }
                return flag;
            },

            checkVacationWithinCall(vacations) {
                if(vacations && vacations.length>0){
                    return true;
                }else{
                    return false;
                }
            },

            limitExceedPopup(emp_id){
                
                if(this.selectedEmployeesToAssign.length == this.unassignedCallCount){
                    this.$modal.show("limitExcedPop");
                    
                }
               
            },

            checkOtherBookingConflict(emp,value) {
                
                let status = false;
                if(value){
                    for(let i=0; i<emp.bookings.length; i++){
                        if(emp.bookings[0].client_id != this.userClientID) {
                            // console.log("check" + i);
                            status = true;
                        }
                    }
                    if(status==true) {
                        this.selectedEmployeeID = emp.id;
                        this.$modal.show("otbConflictPop");
                    }else {
                        this.selectedEmployeeID = null;
                        this.limitExceedPopup(emp.id);
                    }
                }
            },

            closeOtbConflictPop() {
                
                const index = this.selectedEmployeesToAssign.indexOf(this.selectedEmployeeID);
                if (index > -1) {
                    this.selectedEmployeesToAssign.splice(index, 1);
                }
                this.$forceUpdate();
                
                this.$modal.hide("otbConflictPop");
            },

            proceedWithConflict(emp_id){
                this.limitExceedPopup(emp_id);
                this.$modal.hide("otbConflictPop");
            },

            closeLimitPop() {
                this.$modal.hide("limitExcedPop");
            },

            sortDynamic(type){

                switch(type){
                    case "employee_name":
                        if(this.selectedSortType=='fname_asc'){
                            this.selectedSortType='lname_asc';
                        }else{
                            this.selectedSortType='fname_asc';
                        }
                        break;

                    case "skill_seniority":
                        if(this.selectedSortType=='skill_seniority'){
                            this.selectedSortType='skill_seniority_desc';
                        }else{
                            this.selectedSortType='skill_seniority';
                        }
                        break;

                    case "employee_seniority":
                        if(this.selectedSortType=='emp_seniority'){
                            this.selectedSortType='emp_seniority_desc';
                        }else{
                            this.selectedSortType='emp_seniority';
                        }
                        break;

                    case "shift_count_total":
                        if(this.selectedSortType=='shift_total_asc'){
                            this.selectedSortType='shift_total_desc';
                        }else{
                            this.selectedSortType='shift_total_asc';
                        }
                        break;

                    case "shift_count_ytd":
                        if(this.selectedSortType=='shift_YTD_asc'){
                            this.selectedSortType='shift_YTD_desc';
                        }else{
                            this.selectedSortType='shift_YTD_asc';
                        }
                        break;

                    case "shifts_this_week":
                        if(this.selectedSortType=='shift_weekly_asc'){
                            this.selectedSortType='shift_weekly_desc';
                        }else{
                            this.selectedSortType='shift_weekly_asc';
                        }
                        break;

                    case "shifts_ytd_july_june":
                        if(this.selectedSortType=='shift_july_june_asc'){
                            this.selectedSortType='shift_july_june_desc';
                        }else{
                            this.selectedSortType='shift_july_june_asc';
                        }
                        break;

                    case "declines_total":
                        if(this.selectedSortType=='decline_total__asc'){
                            this.selectedSortType='decline_total__desc';
                        }else{
                            this.selectedSortType='decline_total__asc';
                        }
                        break;

                    case "declines_ytd":
                            if(this.selectedSortType=='decline_YTD_asc'){
                                this.selectedSortType='decline_YTD_desc';
                            }else{
                                this.selectedSortType='decline_YTD_asc';
                            }
                        break;

                    case "declines_ytd_july_june":
                        if(this.selectedSortType=='decline_july_june_asc'){
                            this.selectedSortType='decline_july_june_desc';
                        }else{
                            this.selectedSortType='decline_july_june_asc';
                        }
                        break;

                    case "decline_this_week":
                        if(this.selectedSortType=='decline_weekly_asc'){
                            this.selectedSortType='decline_weekly_desc';
                        }else{
                            this.selectedSortType='decline_weekly_asc';
                        }
                        break;

                    case "employee_cell_phone":
                        if(this.selectedSortType=='phone_asc'){
                            this.selectedSortType='phone_desc';
                        }else{
                            this.selectedSortType='phone_asc';
                        }
                        break;

                    case "conflicts":
                        if(this.selectedSortType=='conflicts_asc'){
                            this.selectedSortType='conflicts_desc';
                        }else{
                            this.selectedSortType='conflicts_asc';
                        }
                        break;

                    case "location":
                        if(this.selectedSortType=='location_asc'){
                            this.selectedSortType='location_desc';
                        }else{
                            this.selectedSortType='location_asc';
                        }
                        break;

                    case "participation":
                        if(this.selectedSortType=='participation_asc'){
                            this.selectedSortType='participation_desc';
                        }else{
                            this.selectedSortType='participation_asc';
                        }
                        break;

                    case "participation_july_june_desc":
                        if(this.selectedSortType=='participation_july_june_desc'){
                            this.selectedSortType='participation_july_june_asc';
                        }else{
                            this.selectedSortType='participation_july_june_desc';
                        }
                        break;

                    case "last_offer":
                        if(this.selectedSortType=='last_offer_asc'){
                            this.selectedSortType='last_offer_desc';
                        }else{
                            this.selectedSortType='last_offer_asc';
                        }
                        break;

                    case "last_assigned":
                        if(this.selectedSortType=='last_assigned_asc'){
                            this.selectedSortType='last_assigned_desc';
                        }else{
                            this.selectedSortType='last_assigned_asc';
                        }
                        break;

                    case "last_confirmed":
                        if(this.selectedSortType=='last_confirmed_asc'){
                            this.selectedSortType='last_confirmed_desc';
                        }else{
                            this.selectedSortType='last_confirmed_asc';
                        }
                        break;


                    case "wishlist":
                        if(this.selectedSortType=='wishlist_asc'){
                            this.selectedSortType='wishlist_desc';
                        }else{
                            this.selectedSortType='wishlist_asc';
                        }
                        break;

                    case "custom_field1":
                        if(this.selectedSortType=='custom_field1_asc'){
                            this.selectedSortType='custom_field1_desc';
                        }else{
                            this.selectedSortType='custom_field1_asc';
                        }
                        break;

                    case "custom_field2":
                        if(this.selectedSortType=='custom_field2_asc'){
                            this.selectedSortType='custom_field2_desc';
                        }else{
                            this.selectedSortType='custom_field2_asc';
                        }
                        break;

                    case "member_since":
                        if(this.selectedSortType=='member_since_asc'){
                            this.selectedSortType='member_since_desc';
                        }else{
                            this.selectedSortType='member_since_asc';
                        }
                        break;

                    case "date_of_hire":
                        if(this.selectedSortType=='date_of_hire_asc'){
                            this.selectedSortType='date_of_hire_desc';
                        }else{
                            this.selectedSortType='date_of_hire_asc';
                        }
                        break;

                }
                this.getEmployeesBySkill();
            },
            async pollData () {
                this.polling = setInterval(async () => {
                    
                        if(document.visibilityState === 'visible'){
                            this.timerState = "Started"
                        }else {
                            this.timerState = "Paused"
                        }
                    

                    if (this.timerState === "Started") {
                        
                        await this.getEmployeesBySkill();
                    }
                }, 60000);
            }
        },
        async created() {
            this.$Progress.start();
            this.loading=true;
            await this.checkDispatcherSkill();
            await this.checkStewardSkill();
            
            if(this.clientDetails) {
                console.log(this.clientDetails)
                this.client=JSON.parse(JSON.stringify(this.clientDetails));
            }else {
                console.log('check 123')
                await this.getClientData();
            }
            this.unassignedCallCount=this.noOfUnassignCall;
            
            await this.jobDetails();
            await this.getEmpDetails();
            this.getBaseURL = global[0].IMAGE_URL;
            if(this.job) {
                document.title = `${this.job.job_number}#${this.job.title}`;
            }
            bus.$on('callUnDecline', async (decline) => {
                
                await this.getEmployeesBySkill();
            });
            if(this.client){
                this.turnoverTime= this.client.turnover;
                this.selectedSortType= this.client.default_sort;
                this.customField1 =  this.client.custom_field_1;
                this.customField2 = this.client.custom_field_2;
                this.showCustom = this.client.employee_title;
                this.callAssigmentSettings = this.client.settings['call-assignment-config'];
                this.statusSortType = this.client.assign_page_default_status;
            }
            if(this.employeeStatusList) {
                this.statusList = JSON.parse(JSON.stringify(this.employeeStatusList));
            }
            if(this.statusSortType == 'all'){
                this.selectedStatusId='';
            }else if(this.statusSortType == 'priority'){
                this.selectedStatusId = this.statusList.length?this.statusList[0].id:'';
                this.tempStatus = this.selectedStatusId;
            }
            this.onChangeStatus();

            bus.$on('changeSort', (data) => {
                this.sortDynamic(data);
            });
        },
        mounted(){
            let self = this;
            if(this.job) {
                document.getElementById('assign-emp-search').focus();
            }

            $(window).on('keydown', function(e) {
                if(e.keyCode === 40){
                    // document.getElementById('page-data-focus').focus();
                    e.preventDefault();
                    self.onPageChangeScrollDown();
                }else if(e.keyCode === 38){
                    // document.getElementById('page-data-focus').focus();
                    e.preventDefault();
                    self.onPageChangeScrollUp();
                }
            });

            var totalHeight = $('.o-header').height() + $('.table_header_wrapper').height()+115;
            var windowHeight = $(window).height();
            var adjustedHeight = windowHeight - totalHeight;
            if(adjustedHeight<250){
                $('.tbl-content').css('height', 200);
            }else{
                $('.tbl-content').css('height', adjustedHeight);
            }
            $("#fc_frame").css('display', 'none');
        },

        beforeDestroy(){
            $("#fc_frame").css('display', 'block');
            $(window).off('keydown');
            bus.$off('changeSort');
        },
    }


</script>
<style scoped>
.w-50px{
    width: 50px !important;
}
.fa-minus-circle-red {
    color: #FF5615!important;
}
.o-common-modal-content {
    border-radius: 3px !important;
    padding: 0px!important;
    background-color: #ffffff;
    border: 2px solid #000000!important;
}

.modal-title {
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    background-color: #F67801;
    border-bottom: 2px solid #000000;
}

.close {
    text-shadow: 0 0 0 #000000!important;
    font-size: 15px;
}

.custom-modal--close {
    opacity: 1;
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 20px;
    width: 20px;
    height: 20px;
    background-color: #F67801!important;
    color: #000000!important;
    padding: 0 !important;
    text-shadow: #000000!important;
    margin-top: 0;
}

.obt-modal-cancel-btn {
    background-color: #F67801;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}
.obt-modal-proceed-btn {
    background-color: #17A068;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}

.obt-conflict-body {
    line-height: 1.5;
    font-size: 15px;
    font-weight: 500;
    padding: 10px 10px 0;
}

.display-inline{
    display: flex;
}

.global-skill-display {
    font-size: 13px;
    font-weight: 500;
    width: 22px;
    height: 20px;
    color: #000000;
    background-color: #F67801;
    margin-top: -3px;
    text-align: center;
    padding: 3px;
}

#assign-emp-search:focus {
    border: 2px solid #337ab7;
}
#assign-emp-sort:focus {
    border: 2px solid #337ab7;
}
#selectedStatus:focus {
    border: 2px solid #337ab7;
}
.select_margin_adjust{
    width: 230px;
}
.h5-v1 {
    font-size: 18px;
    margin-right: 5px;
}
/* .table_1 .calls-table-row .tcell_1 {
    width: 70px !important;
}
.o-custom-radio label {
    width: auto !important;
} */
</style>
